// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cUEfrXImGew9_3 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--ds-space-200, 16px) var(--ds-space-300, 24px);
  background-color: var(--ds-background-neutral-bold, #44546f);
  color: var(--ds-text-inverse, #ffffff);
}
.Ae_BI15Cx3MI2M {
  position: relative;
  text-align: center;
}
.g2B6ZaQOvD7JXZ {
  position: relative;
  top: var(--ds-space-025, 2px);
  margin: var(--ds-space-050, 4px) var(--ds-space-100, 8px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var banner = `cUEfrXImGew9_3`;
export var text = `Ae_BI15Cx3MI2M`;
export var icon = `g2B6ZaQOvD7JXZ`;
export default ___CSS_LOADER_EXPORT___;
